/**
 * 勤怠打刻情報
 */
export interface AttendanceClock {
  timestamp: Date;
  location?: {
    latitude: number;
    longitude: number;
    accuracy: number;
  };
  deviceInfo?: string;
  note?: string;
  isTestMode?: boolean; // テスト環境用（GPS位置を店舗に設定）
}

/**
 * 休憩情報
 */
export interface AttendanceBreak {
  startTime: Date;
  endTime?: Date;
  breakMinutes?: number;
}

/**
 * 勤怠情報
 */
export interface Attendance {
  id: string;
  shopId: string;
  employeeId: string;
  shiftId?: string;

  // 勤務日
  workDate: Date;

  // 打刻情報
  clockIn?: AttendanceClock;
  clockOut?: AttendanceClock;

  // 遅刻・早退
  isLate: boolean;
  lateMinutes: number;
  lateReported?: boolean;
  lateReason?: string;
  lateApproved?: boolean;
  lateApprovedBy?: string;
  lateApprovedAt?: Date;

  isEarlyLeave: boolean;
  earlyLeaveMinutes: number;
  earlyLeaveRequested?: boolean;
  earlyLeaveReason?: string;
  earlyLeaveApproved?: boolean;
  earlyLeaveApprovedBy?: string;
  earlyLeaveApprovedAt?: Date;

  // 休憩
  breaks: AttendanceBreak[];

  // 勤務時間
  workMinutes?: number;
  breakMinutes?: number;
  actualWorkMinutes?: number;

  // ステータス
  status: 'working' | 'break' | 'completed' | 'absent';

  // メモ
  note?: string;

  // システム情報
  createdAt: Date;
  updatedAt: Date;
}

/**
 * 月次勤怠サマリー
 */
export interface MonthlyAttendanceSummary {
  employeeId: string;
  shopId: string;
  year: number;
  month: number;
  workDays: number;
  totalWorkMinutes: number;
  totalBreakMinutes: number;
  totalActualWorkMinutes: number;
  lateDays: number;
  totalLateMinutes: number;
  earlyLeaveDays: number;
  totalEarlyLeaveMinutes: number;
  absentDays: number;
  estimatedSalary?: number;
}

/**
 * 勤怠ステータスの日本語表示
 */
export const attendanceStatusLabels: Record<Attendance['status'], string> = {
  working: '勤務中',
  break: '休憩中',
  completed: '退勤',
  absent: '欠勤',
};

/**
 * 勤怠ステータスの色
 */
export const attendanceStatusColors: Record<Attendance['status'], 'default' | 'primary' | 'success' | 'warning' | 'error'> = {
  working: 'primary',
  break: 'warning',
  completed: 'success',
  absent: 'error',
};
